import "./ButtonLink.css";

import cx from "classnames";
import { memo } from "react";

function ButtonLink({ children, className = undefined, onClick }) {
  return (
    <button
      className={cx("buttonLink", className)}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}

export default memo(ButtonLink);
